import { useState, useEffect } from "react"
import { loadEnvVars } from "../utils/loadEnvVars"
import axios, { AxiosError } from "axios"

const { expressApiGateway } = loadEnvVars()

export const useMaintenanceStatus = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [error, setError] = useState<AxiosError | null>(null)

  useEffect(() => {
    const getAppStatus = async () => {
      try {
        const url = `${expressApiGateway}/maintenance`
        const { data } = await axios.get<boolean>(url)
        setIsActive(data)
      } catch (error) {
        setError(error as AxiosError)
      } finally {
        setIsLoading(false)
      }
    }
    getAppStatus()
  }, [])

  return { isLoading, isActive, error }
}
